// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { map } from 'ramda';
import colors from '../../styles/colors';
import ResponsivePieChart from '../../components/charts/pie';
import '../style.css';


type Props = {}

type ViewModel = {
  label: string,
  value: number,
  color?: string,
  text?: string,
}

const LabelStrings: Object = {
  achieved: 'Achieved',
  remaining: 'Remaining',
  planCompleted: 'Plan Complated',
  planRemaining: 'Plan Remaining',
};

const styles: Object = {

  widget: {
    width: '50%',
    border: '1px solid rgb(220, 220, 220)',
    padding: '1rem',
    background: '#fff',
    boxShadow: '0 0 6px 3px rgba(156, 156, 156, 0.1)',
    margin: '0.5rem',
  },
  noData: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px',
  },
};

const formatData: Function = function formatData(data: any): any[] {
  return map((key: string): any => (
    {
      id: key,
      value: data[key].value,
      percentage: data[key].percentage,
      totalDays: data[key].days,
    }
  ), Object.keys(data));
};

const dummyData: any = {
  achieved: {
    value: 10,
    percentage: 55.6,
    totalDays: 10,
  },
  remaining: {
    value: 8,
    percentage: 22.2,
    totalDays: 8,
  },
};

const dummyData01: any = {
  planCompleted: {
    value: 10,
    percentage: 60.6,
    totalDays: 10,
  },
  planRemaining: {
    value: 8,
    percentage: 40.2,
    totalDays: 8,
  },
};

const ColorConfig: Object = {
  Achieved: colors.themeSecondaryColorNew,
  Remaining: colors.themePrimaryColorNew,
  'Plan Complated': colors.themeSecondaryColorNew,
  'Plan Remaining': colors.themePrimaryColorNew,
};

class ProjectOverallProgressWidget extends React.PureComponent<Props> {
  getDaysDeltaText(item: Object): string {
    if (item.id === 'shortened' || item.id === 'extended') {
      return `${item.totalDays} days`;
    }
    return '';
  }

  getFormattedData(data: Array<Object>): ViewModel[] {
    return data.map((item: Object): ViewModel => ({
      label: LabelStrings[item.id],
      value: item.percentage,
    }));
  }

  getChartData(data: Array<Object>): ViewModel[] {
    return data.map(
      (item: Object): Object => ({
        label: item.label,
        value: item.value,
        color: ColorConfig[item.label],
        // text: item.text,
      }),
    );
  }

  getWidget(): React.Node {
    if (formatData(dummyData).length !== 0) {
      return (
        <div className="c-level__flex">
          <div style={{ width: '50%' }}>
            <ResponsivePieChart
              data={this.getChartData(this.getFormattedData(formatData(dummyData)))}
              dataOptions={{
                pull: [0.1, 0, 0],
              }}
            />
          </div>
          <div style={{ width: '50%' }}>
            <ResponsivePieChart
              data={this.getChartData(this.getFormattedData(formatData(dummyData01)))}
              dataOptions={{
                pull: [0.1, 0, 0],
              }}
            />
          </div>
        </div>
      );
    }
    return (
      <span style={styles.noData}>
      No data available
      </span>
    );
  }


  render(): React.Node {
    /* eslint max-len: ["error", { "ignoreStrings": true, "code": 150}] */
    return (
      <section style={styles.widget}>
        <div style={styles.chart}>
          <h1>
            Civil Works
            {' '}
          </h1>
          {
            this.getWidget()
          }
        </div>
      </section>
    );
  }
}

const Component: any = connect()(ProjectOverallProgressWidget);

// Component.style = {
//   width: '98%',
// };

export default Component;
